<template>
  <div class="medai-gallery-video-item">
    <video-player class="video-player-box vjs-custom-skin" ref="videoPlayer" v-if="options" :options="options" @play="onPlay"></video-player>
  </div>
</template>

<script>
import mime from 'mime';

import { videoPlayer } from 'vue-video-player';
import 'video.js/dist/video-js.css';
import 'vue-video-player/src/custom-theme.css';

export default {
  name: 'MediaGalleryVideoItem',
  components: {
    videoPlayer,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // options: null,
      played: false,
    };
  },
  computed: {
    sources() {
      return [
        {
          src: this.item.video.url,
          type: this.getMediaType(this.item),
        },
        ...(this.item.additionalSources || []).map(additionalItem => ({
          src: additionalItem.video.url,
          type: this.getMediaType(additionalItem),
        })),
      ];
    },
    options() {
      return {
        fluid: true,
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: this.sources,
        poster: this.item.poster && this.item.poster.url,
        controlBar: {
          remainingTimeDisplay: false,
          pictureInPictureToggle: false,
        },
      };
    },
  },
  methods: {
    getMediaType(mediaItem) {
      return mime.getType(mediaItem.video.ref || '');
    },
    onPlay() {
      if (!this.played) {
        this.$ga.event('video', 'play', this.item.video.ref);
        this.played = true;
      }
    },
  },
};

</script>



// WEBPACK FOOTER //
// src/components/MediaGalleryVideoItem.vue